import BackendService from "../../../../src/services/backend.service";

class SharedUtils {

    apiPost = async (endpoint, jsondata, reload = false, withmsg = false, downloadfile = false) => {
        return await BackendService.postJSON(endpoint, jsondata, false, reload, withmsg, downloadfile).then(async (response) => {
            return await Promise.all([response]).then((arrList) => {
                return arrList;
            });
        });
    };


    apiDownload = async (endpoint, jsondata) => {
        return await BackendService.postDownfile(endpoint, jsondata).then(async (response) => {
            return await Promise.all([response]).then((arrList) => {
                return arrList;
            });
        });
    };


    filePost = async (endpoint, file, reload = false, withmsg = false, downloadfile = false) => {
        return await BackendService.postJSON(endpoint, file, true, reload, withmsg, downloadfile).then(async (response) => {
            return await Promise.all([response]).then((arrList) => {
                return arrList;
            });
        });
    };

    getLocalTimeZone = (date) =>{
    const dateformat = {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric'
                       };
    // Get the local time zone offset in minutes
    const timeZoneOffsetMinutes = new Date().getTimezoneOffset();

    // Convert the offset to hours and calculate the sign
    const sign = timeZoneOffsetMinutes > 0 ? '-' : '+';
    const hours = Math.abs(Math.floor(timeZoneOffsetMinutes / 60));

    // Create a string representation of the time zone
    const timeZoneString = `GMT${sign}${hours}`;

    const localTimeDate = new Date(date).toLocaleDateString('en-US', dateformat) + " (" + timeZoneString + ")"

    return localTimeDate

    }

    doSsoLogin = async (id, token, type) => {

         
        let x = await this.apiPost("validate_sso/" + type, { "token": token, client_id: id.clientid }, false, true);

        if (x[0].data['msg'] == 'OK') {
            localStorage.setItem("reduxState",
                JSON.stringify({
                    "auth": { "username": x[0].data['username'], "token": x[0].data['token'], "refresh": x[0].data['refresh'] },
                    "header": { "isOpen": false }
                }));


            localStorage.setItem("client_name", id['client_name']);

            if (window.location.href.includes('login')) {
                window.location = "/";

            }
            else {
                window.location = window.location;
            }
   
        }
        else {
            return x[0]['msg'];
        }
    }



}



export default new SharedUtils();